var stripHtml = function(text) {
    return text.replaceAll(/<[^>]+?>/g, " ") // Remove HTML tags
    .replaceAll(/\s+/g, " ") // Collapse multiple spaces
    .replaceAll(/\\r\\n|\\n|\\r/g, " ") // Remove escaped newlines
    .trim();
};
var cleanRedundantPhrases = function(message) {
    var cleaned = message.replaceAll(/^(error:\s*)+/gi, "");
    cleaned = cleaned.replaceAll(/^(bad request:\s*)+/gi, "");
    cleaned = cleaned.replaceAll(/^(something went wrong:\s*)+/gi, "");
    cleaned = cleaned.replaceAll(/^(failed:\s*)+/gi, "");
    cleaned = cleaned.replaceAll(/\b(\w+(?:\s+\w+)*):\s*\1:/gi, "$1:");
    return cleaned.trim();
};
var containsHtml = function(message) {
    return /<\/?[a-z][\s\S]*>/i.test(message);
};
var containsTechnicalDetails = function(message) {
    return message.includes('{"response"') || message.includes('"headers"') || message.includes('"x-amz-') || message.includes("CloudFront") || message.includes("nginx") || message.includes("envoy");
};
var simplifyGraphQLError = function(message) {
    if (message.includes("field") && message.includes("not found")) {
        return "The requested data is not available";
    }
    if (message.includes('Missing "where" clause')) {
        return "Invalid data request";
    }
    if (message.includes("query_root") || message.includes("mutation_root")) {
        return "The requested operation is not available";
    }
    return message;
};
export var transformStringError = function(errorMessage) {
    var message = errorMessage;
    if (containsHtml(message)) {
        message = stripHtml(message);
    }
    if (message.includes("504") || message.includes("Gateway Time-out")) {
        return "The service is taking longer than expected to respond. Please try again in a moment.";
    }
    if (message.includes("502")) {
        return "We're having trouble connecting to the service. Please try again in a moment.";
    }
    message = cleanRedundantPhrases(message);
    message = simplifyGraphQLError(message);
    return message;
};
export var transformErrorMessage = function(error) {
    var message = error.rawErrorMessage || error.message;
    var originalMessage = message;
    if (containsHtml(message)) {
        message = stripHtml(message);
        if (message.includes("504") || message.includes("Gateway Time-out")) {
            return {
                heading: "Service Temporarily Unavailable",
                message: "The service is taking longer than expected to respond. This is usually temporary.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    },
                    {
                        label: "Contact Support",
                        type: "contactSupport"
                    }
                ]
            };
        }
    }
    if (containsTechnicalDetails(originalMessage)) {
        if (originalMessage.includes('"status":504')) {
            return {
                heading: "Service Temporarily Unavailable",
                message: "The service is taking longer than expected to respond. Please try again in a moment.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    }
                ]
            };
        }
        if (originalMessage.includes('"status":502')) {
            return {
                heading: "Service Connection Issue",
                message: "We're having trouble connecting to the service. Please try again in a moment.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    }
                ]
            };
        }
    }
    message = cleanRedundantPhrases(message);
    var simplifiedMessage = simplifyGraphQLError(message);
    var wasSimplified = simplifiedMessage !== message;
    message = simplifiedMessage;
    switch(error.code){
        case "validation-failed":
            return {
                heading: "Invalid Request",
                message: wasSimplified ? message : message || "Please check your input and try again.",
                recoveryActions: [
                    {
                        label: "Go Back",
                        type: "goBack"
                    }
                ]
            };
        case "access-denied":
            return {
                heading: "Access Denied",
                message: message || "You don't have permission to access this resource. Please sign in or contact your administrator.",
                recoveryActions: [
                    {
                        label: "Sign In Again",
                        type: "refresh"
                    },
                    {
                        label: "Go Back",
                        type: "goBack"
                    },
                    {
                        label: "Contact Support",
                        type: "contactSupport"
                    }
                ]
            };
        case "forbidden":
            return {
                heading: "Session Expired",
                message: "Your session has expired. Please sign in again to continue.",
                recoveryActions: [
                    {
                        label: "Sign In",
                        type: "refresh"
                    }
                ]
            };
        case "not-found":
            return {
                heading: "Not Found",
                message: message || "The resource you're looking for doesn't exist or has been removed.",
                recoveryActions: [
                    {
                        label: "Go Back",
                        type: "goBack"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    }
                ]
            };
        case "conflict":
            return {
                heading: "Conflict",
                message: message || "This action conflicts with the current state. Please refresh and try again.",
                recoveryActions: [
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    },
                    {
                        label: "Go Back",
                        type: "goBack"
                    }
                ]
            };
        case "rate-limit":
            return {
                heading: "Too Many Requests",
                message: "You've made too many requests. Please wait a moment and try again.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    }
                ]
            };
        case "payment-required":
            return {
                heading: "Payment Required",
                message: message || "This feature requires payment or an upgraded plan. Please check your subscription.",
                recoveryActions: [
                    {
                        label: "Contact Sales",
                        type: "contactSupport"
                    }
                ]
            };
        case "internal-server-error":
        case "bad-gateway":
            return {
                heading: "Service Error",
                message: "We're experiencing technical difficulties. Please try again in a moment.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    },
                    {
                        label: "Contact Support",
                        type: "contactSupport"
                    }
                ]
            };
        case "gateway-timeout":
            return {
                heading: "Request Timeout",
                message: "The request is taking longer than expected. Please try again.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    }
                ]
            };
        case "not-implemented":
            return {
                heading: "Feature Not Available",
                message: message || "This feature is not yet available. Please check back later.",
                recoveryActions: [
                    {
                        label: "Go Back",
                        type: "goBack"
                    },
                    {
                        label: "Contact Support",
                        type: "contactSupport"
                    }
                ]
            };
        case "unknown":
        default:
            return {
                heading: "Something Went Wrong",
                message: message || "An unexpected error occurred. Please try again or contact support if the problem persists.",
                recoveryActions: [
                    {
                        label: "Try Again",
                        type: "retry"
                    },
                    {
                        label: "Refresh Page",
                        type: "refresh"
                    },
                    {
                        label: "Contact Support",
                        type: "contactSupport"
                    }
                ]
            };
    }
};
export var getUserFriendlyMessage = function(error) {
    var transformed = transformErrorMessage(error);
    return transformed.message;
};
export var getErrorHeading = function(error) {
    var transformed = transformErrorMessage(error);
    return transformed.heading;
};
export var getRecoveryActions = function(error) {
    var transformed = transformErrorMessage(error);
    return transformed.recoveryActions || [];
};

//# sourceMappingURL=errorMessageTransformer.js.map